import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Field extends RESTSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    optionSetIds: { serialize: 'ids' },
  };

  payloadKeyFromModelName(modelName) {
    return modelName.replace(/^school-options\/field/, 'option');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace(/^option/, 'school-options/field'),
    );
  }

  normalize(model, hash, prop) {
    let defaults = {
      sequence: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
